import { createContext, useSyncExternalStore } from 'react';

/** Touch-generated compatibility mouse events must not reveal keyboard hints. */
export const TooltipTouchContext = createContext(false);
let touchInput = false;
const subscribers = new Set<() => void>();

function update(touch: boolean) {
  if (touchInput === touch) return;
  touchInput = touch;
  for (const notify of subscribers) notify();
}
function onPointer(event: PointerEvent) {
  if (event.pointerType) update(event.pointerType === 'touch');
}
function onTouch() {
  update(true);
}
function onKeyboard() {
  update(false);
}
function subscribe(notify: () => void) {
  if (subscribers.size === 0) {
    document.addEventListener('pointerdown', onPointer, true);
    document.addEventListener('pointerover', onPointer, true);
    document.addEventListener('pointermove', onPointer, true);
    document.addEventListener('touchstart', onTouch, { capture: true, passive: true });
    document.addEventListener('keydown', onKeyboard, true);
  }
  subscribers.add(notify);
  return () => {
    subscribers.delete(notify);
    if (subscribers.size !== 0) return;
    document.removeEventListener('pointerdown', onPointer, true);
    document.removeEventListener('pointerover', onPointer, true);
    document.removeEventListener('pointermove', onPointer, true);
    document.removeEventListener('touchstart', onTouch, true);
    document.removeEventListener('keydown', onKeyboard, true);
    touchInput = false;
  };
}

// One listener set for all tooltips, with no updates during ordinary mouse motion.
// Release/cancel retain touch origin until real mouse or keyboard input arrives.
export function useTooltipTouchInput() {
  return useSyncExternalStore(
    subscribe,
    () => touchInput,
    () => false,
  );
}
